import { Pipe, PipeTransform } from '@angular/core';
import { PublicationService } from 'app/services/publication.service';

@Pipe({name: 'bbDate'})

export class BbDatePipe implements PipeTransform {

	constructor(private publicationService: PublicationService) {
	}

	transform(
		dateTime: string | Date,
		type: 'date-day-time' | 'date-time' | 'date' | 'time' | 'relative' = 'date-day-time',
		format: 'short' | 'medium' | 'long' | 'numeric' | 'narrow' = 'short',
		optionOverrides?: any
	): string {
		const locale = this.publicationService.locale; // when we have multi-language support maybe use navigator.language or other locale info.

		let formattedDate = '';
		if (!dateTime) {
			return '';
		}
		const date = new Date(dateTime);
		let options: Intl.DateTimeFormatOptions = {};
		if (typeof dateTime === 'object') {
			dateTime = String(dateTime);
		}

		const dateObject = new Date(dateTime);
		if (type === 'relative') {
			if (!Intl.RelativeTimeFormat) {
				// Safari 13 and lower does not support RelativeTimeFormat
				return '';
			}
			const nowDate = new Date();
			const rtf = new Intl.RelativeTimeFormat(locale, { numeric: 'auto' });

			const timeDiffMs = dateObject.getTime() - nowDate.getTime();
			const timeDiffSeconds = Math.floor(timeDiffMs / 1000);
			const timeDiffMinutes = Math.round(timeDiffSeconds / 60);
			const timeDiffDays = Math.round(timeDiffSeconds / 3600 / 24);

			if (Math.abs(timeDiffSeconds) < 50) {
				formattedDate = rtf.format(timeDiffSeconds, 'seconds');
			} else if (Math.abs(timeDiffMinutes) < 30) {
				formattedDate = rtf.format(timeDiffMinutes, 'minutes');
			} else if (Math.abs(timeDiffDays) === 0) {
				options.hour = 'numeric';
				options.minute = 'numeric';
			} else if (dateObject.getFullYear() === nowDate.getFullYear()) {
				options = {
					month: format as any,
					day: 'numeric'
				};
			} else {
				options = {
					year: 'numeric',
					month: format as any,
					day: 'numeric'
				};
			}
		} else {
			if (type.includes('date')) {
				options = { ...options, ...{
					year: 'numeric', // format === 'short' ? '2-digit' : 'numeric',
					month: format,
					day: 'numeric'
				}} as any;
				if (optionOverrides) {
					if (optionOverrides.hideYear) {
						delete options.year;
					}
					if (optionOverrides.hideMonth) {
						delete options.month;
					}
					if (optionOverrides.hideDay) {
						delete options.day;
					}
				}
			}
			if (type.includes('day') || (type.includes('date') && format === 'medium')) {
				options.weekday = format as any;
			}

			if (type.includes('time')) {
				options.hour = 'numeric';
				options.minute = 'numeric';
				if (format === 'medium' || format === 'long') {
					options.second = 'numeric';
				}
				options = { ...options, ...{
					hour: 'numeric',
					minute: 'numeric'
				}};
			}
		}


		if (typeof optionOverrides === 'object') {
			options = { ...options, ...optionOverrides};
		}
		return (formattedDate || Intl.DateTimeFormat(locale, options).format(date));
	}
}
